// extracted by mini-css-extract-plugin
export default {"container":"ShelfEmptyState_container__PYOFH","title":"ShelfEmptyState_title__CEjeS","bookIcon":"ShelfEmptyState_bookIcon__TI0Ot"};